import BaseAPI from "./BaseAPI";
import ServiceApiUrlsStore from "../stores/ServiceApiUrlsStore";
import {
  cleanupOrganization,
  cleanupUser,
  cleanupDetail,
} from "./CleanupPolyfills";

class UserAPIWrapper {
  constructor(api) {
    this.api = api;
  }

  getCurrentUser() {
    return this.api
      .get("/api/v1/users/current")
      .then((data) => ({ user: cleanupUser(data.body.user) }));
  }

  getOrgWithSiteUrl(siteUrl) {
    return this.api
      .get(`/api/v1/organizations/styling/${siteUrl}`)
      .then((data) => ({
        organization_styling: cleanupDetail(data.body.organization_styling),
      }));
  }

  getUser(id) {
    return this.api.get(`/api/v1/users/${id}`).then((data) => data.body);
  }

  getOrganization(id) {
    return this.api.get(`/api/v1/organizations/${id}`).then((data) => ({
      organization: cleanupOrganization(data.body.organization),
    }));
  }

  getRole(id) {
    return this.api.get(`/api/v1/roles/${id}`).then((data) => data.body);
  }

  createUser(email, organizationId, roleId) {
    const url = "/api/v1/users";

    const payload = {
      user: {
        email,
        organization_id: organizationId,
        role_id: roleId,
      },
    };

    return this.api.post(url, payload).then((data) => data.body);
  }

  updateMembership(userId, organizationId, roleId) {
    const url = `/api/v1/users/${userId}/organizations/${organizationId}`;

    const payload = {
      membership: {
        role_id: roleId,
      },
    };

    return this.api.put(url, payload).then((data) => data.body);
  }

  deleteMembership(userId, organizationId) {
    const url = `/api/v1/users/${userId}/organizations/${organizationId}`;

    return this.api.del(url).then((data) => data.body);
  }

  updateMembershipDetail(userId, organizationId, tableauUser) {
    const url = `/api/v1/users/${userId}/organizations/${organizationId}/detail`;

    const payload = {
      membership_detail: {
        tableau_user: tableauUser,
      },
    };

    return this.api.put(url, payload).then((data) => data.body);
  }

  acceptEula(organizationId) {
    return this.api
      .post("/api/v1/users/current/accept_eula", {
        organization_id: organizationId,
      })
      .then((data) => data.body);
  }

  getActiveUsers(orgId) {
    return this.api
      .get(`/api/v1/organizations/${orgId}/active_users`)
      .then((data) => data.body);
  }

  getDaemonUsers(orgId) {
    return this.api
      .get(`/api/v1/organizations/${orgId}/daemons`)
      .then((data) => data.body);
  }
}

class UserAPI extends BaseAPI {
  constructor(token) {
    super(ServiceApiUrlsStore.getUserServiceUrl(), token);
    this.users = new UserAPIWrapper(this);
  }
}

export default UserAPI;
